/**
 * 来場者サンクスページ
 * スタンプラリーの開催終了後、開いていた景品交換の画面以外に代えて表示します。
 */

import React from 'react';
import { ScrollView } from '../../../shared/components/WebPrimitives';
import PixelHeroMascot from '../../../shared/components/PixelHeroMascot';
import ScreenLayout from '../../../shared/components/ScreenLayout';
import usePublicAppSettings from '../../../shared/hooks/usePublicAppSettings';
import FestivalOrnamentStrip from '../components/FestivalOrnamentStrip';

/**
 * 来場者サンクスページ
 * @returns {JSX.Element} サンクスページ
 */
const VisitorThankYouScreen = (): React.JSX.Element => {
  /** 公開アプリ設定 */
  const { settings } = usePublicAppSettings();

  return (
    <ScreenLayout
      description="スタンプラリーの終了のご案内です。"
      showHeader={false}
      theme="visitor"
      title="ご来場ありがとうございました"
    >
      <ScrollView
        className="flex-1"
        contentContainerClassName="min-h-full justify-center py-2"
        showsVerticalScrollIndicator={false}
      >
        <section className="mx-auto w-full max-w-[560px] border-4 border-app-quest-night bg-app-panel shadow-[6px_6px_0_rgba(22,36,58,0.34)]">
          <FestivalOrnamentStrip />
          <div className="flex flex-col items-center px-5 py-6 text-center">
            <PixelHeroMascot mood="happy" pose="win" />
            <p className="mt-4 text-xs font-extrabold tracking-[2px] text-app-text-secondary" lang="en">
              {settings.festivalLabelEn}
            </p>
            <h1 className="mt-1 break-keep text-[22px] font-extrabold leading-8 text-app-quest-night [overflow-wrap:anywhere]">
              ご来場ありがとう<wbr />ございました！
            </h1>
            <p className="mt-4 text-left text-base leading-7 text-app-text">
              {settings.festivalName}スタンプラリーは終了しました。島をめぐってくれた勇者のみなさん、冒険におつきあいいただきありがとうございました。またのお越しをお待ちしております。
            </p>
          </div>
          <FestivalOrnamentStrip />
        </section>
      </ScrollView>
    </ScreenLayout>
  );
};

export default VisitorThankYouScreen;
